const company = {
    visionTitle:"परिकल्पना",
    vision:"“साहसको आधार, भविष्यको पुर्वाधार”"
}
export default company;